export const GET_NOTEBOOKS = "GET_NOTEBOOKS";
export const GET_NOTEBOOK_BY_ID = "GET_NOTEBOOK_BY_ID";
export const UPDATE_NOTEBOOK = "UPDATE_NOTEBOOK";
export const DELETE_NOTEBOOK = "DELETE_NOTEBOOK";
export const CREATE_NOTEBOOK = "CREATE_NOTEBOOK";
export const GET_NOTEBOOK_USERS = "GET_NOTEBOOK_USERS";
export const GET_INTERDOC_USERS = "GET_INTERDOC_USERS";
export const IMPORT_NOTE = "IMPORT_NOTE";
